import type { ReactNode } from 'react'
import React from 'react'

import * as S from './SubscriptionBadge.styled'

export type SubscriptionPillProps = {
  label?: ReactNode
}

export const SubscriptionBadge = ({ label }: SubscriptionPillProps) => {
  return (
    <S.Container>
      <S.Badge>PRO</S.Badge>
      {label && <S.Label>{label}</S.Label>}
    </S.Container>
  )
}
